export default __webpack_public_path__ + "static/media/forge.65b6d5c2.jpg";